(function() {
  if(document.body.classList.contains('template-product')){
     productreview();
    }
  if(document.body.classList.contains('template-index')){
    pagereview();
  }
})();

function pagereview() {

  const page_review =  document.querySelector('[data-yotpoCls]') || null;

  if(!page_review) return
  
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("accept", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

fetch("https://api.yotpo.com/products/KiV4guafRsIYL5688TDnFrA9WEE6xgEwBy4ixL3d/yotpo_site_reviews/bottomline", requestOptions)
  .then((response) => response.text())
  // .then((result) => console.log(result))
   .then((result) => {
     const result_json = JSON.parse(result);
     if(result_json['status'].code== 200){
          // console.log(result_json['response'].bottomline['average_score']);
          // console.log(result_json['response'].bottomline['total_reviews']);  
       page_review.querySelector('[data-yotpoCls-progreash]').innerHTML = `(${result_json['response'].bottomline['average_score']})`;
       page_review.querySelector('[data-yotpoCls-re-count]').innerHTML = result_json['response'].bottomline['total_reviews'];
       reviewstaradded(result_json['response'].bottomline['average_score'],page_review);
       page_review.classList.remove('hide');
     }
  })
  .catch((error) => console.error(error));
}


function productreview() {
  const content_sel = document.querySelector('[data-yotpoCls-pdp]') || null;
    const product_id_attr =  content_sel.getAttribute('data-product-id') || null;
   const product_id =  parseInt(product_id_attr) || null;

  
if(!content_sel) return;
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("accept", "application/json");

const requestOptions = {
  method: "GET",
  headers: myHeaders,
  redirect: "follow"
};

fetch(`https://api-cdn.yotpo.com/products/KiV4guafRsIYL5688TDnFrA9WEE6xgEwBy4ixL3d/${product_id}/bottomline`, requestOptions)
  .then((response) => response.text())
  // .then((result) => console.log(result))
     .then((result) => {
     const result_json = JSON.parse(result);
       console.log(result_json);
     if(result_json['status'].code== 200){
          // console.log(result_json['response'].bottomline['average_score']);
          // console.log(result_json['response'].bottomline['total_reviews']);  
       
       content_sel.querySelector('[data-yotpoCls-progreash]').innerHTML = `(${result_json['response'].bottomline['average_score']})`;
        content_sel.classList.remove('hide');
     }
  })
  .catch((error) => console.error(error));
  
}

function reviewstaradded(ratingAverage,mainelement) {

  const all_start = mainelement.querySelectorAll('.review_star_static .full_star') || null;
  if(all_start.length > 0);
console.log(all_start.length);
    all_start.forEach(star => {
    star.classList.remove('full_star', 'star_half');
  });

  const fullStars = Math.floor(ratingAverage);
  const decimal = ratingAverage - fullStars;

  // Add full stars
  for (let i = 0; i < fullStars; i++) {
    all_start[i].classList.add('full_star');
  }

  // Add half star if decimal >= 0.7
  if (decimal >= 0.7 && fullStars < 5) {
    all_start[fullStars].classList.add('star_half');
  }
  
}